import React from "react";
import PropTypes from "prop-types";

/**
 * Shown on the Journal tab when the Payment journal (APP) pays out of an HSBC*
 * offset account (HSBC01VND, HSBC01USD…): this request is paid online through HSBC, and the payment leaves
 * the bank right after the BOD signs — there is no later step to stop it.
 */
const HsbcOnlinePaymentNotice = ({ accounts }) => {
  if (!accounts?.length) return null;

  return (
    <div role="alert" aria-label="HSBC online payment"
      className="tw-flex tw-items-start tw-gap-3 tw-rounded-geist-sm tw-border tw-border-solid tw-border-[#f0b45a] tw-bg-[#fff8ee] tw-px-4 tw-py-3">
      <i className="bi bi-bank2 tw-mt-0.5 tw-text-[16px] tw-text-[#a05e03]" aria-hidden="true" />
      <div className="tw-min-w-0 tw-text-[13px] tw-leading-relaxed tw-text-[#7a4a06]">
        <p className="tw-m-0 tw-font-semibold">
          HSBC online payment · offset account {accounts.join(", ")}
        </p>
        <p className="tw-m-0">
          Head of Finance and BOD approve with a digital signature. <strong>Right after the BOD approves, the payment is
          sent to HSBC and paid immediately</strong> — there is no further step to stop it.
        </p>
        <p className="tw-m-0 tw-text-[12px] tw-text-[#a05e03]">
          Check the recipient name, bank account, bank / BIC and the amount before creating the journal.
          Use another bank offset account to pay outside HSBC online.
        </p>
      </div>
    </div>
  );
};

HsbcOnlinePaymentNotice.propTypes = {
  accounts: PropTypes.arrayOf(PropTypes.string),
};

export default HsbcOnlinePaymentNotice;
